import _get from 'lodash/get';


export const getCampaigns = state => _get(state, 'campaign.byId');
export const getCampaign = (state, campaignId) => _get(getCampaigns(state), campaignId);
export const getCampaignStatus = (state, campaignId) => (
  _get(getCampaign(state, campaignId), 'status')
);

export const getCreateCampaignError = state => (
  state.campaign.errors.createCampaignError
);
export const getEditCampaignError = state => (
  state.campaign.errors.editCampaignError
);
export const getSwitchCampaignStatusError = state => (
  state.campaign.errors.switchCampaignStatusError
);
